import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-4 border-b flex justify-between items-center" }
const _hoisted_2 = { class: "text-xl font-bold" }
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = { class: "mb-4 flex justify-between items-center" }
const _hoisted_5 = { class: "text-lg" }
const _hoisted_6 = { class: "text-blue-600" }
const _hoisted_7 = { class: "text-lg" }
const _hoisted_8 = { class: "text-green-600 font-bold" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "overflow-x-auto" }
const _hoisted_11 = { class: "border-collapse border text-sm mx-auto" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "border p-2" }
const _hoisted_14 = { class: "border p-2" }
const _hoisted_15 = { class: "border p-2" }
const _hoisted_16 = { class: "border p-2" }
const _hoisted_17 = { class: "border p-2" }
const _hoisted_18 = { class: "border p-2" }
const _hoisted_19 = { class: "border p-2" }
const _hoisted_20 = { class: "border p-2" }
const _hoisted_21 = { class: "border p-2" }
const _hoisted_22 = { class: "border p-2" }
const _hoisted_23 = { class: "border p-2" }
const _hoisted_24 = { class: "border p-2" }
const _hoisted_25 = {
  colspan: "12",
  class: "border p-2 text-right font-semibold"
}
const _hoisted_26 = { class: "text-blue-600" }

import { ref, onMounted } from 'vue'

type Job = {
  siteInfo?: string
  siteName?: string
  jobDate?: string
  startTime?: string
  endTime?: string
  hours?: number
  totalHours?: number
  payRate?: number
  rate?: number
  adjustment?: number
  adjustmentHours?: number
  remarks?: string
  bonusHours?: number
  netHours?: number
  travelExpense?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PayDetail',
  props: {
    baseUrl: {},
    payId: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const payDetails = ref<Job[]>([])
const employeeName = ref('TBC')
const totalPay = ref(0)
const totalHours = ref(0)

const formatDate = (dateStr?: string) => dateStr ? new Date(dateStr).toLocaleDateString('en-GB') : '-'

const printRow = (row: Job) => alert(`Printing: ${row.siteInfo || row.siteName}`)

const fetchPayDetail = async () => {
  try {
    const res = await fetch(`${props.baseUrl}Pays/ShowPayDetail/${props.payId}`, {
      headers: { "Authorization": `Bearer ${localStorage.token}` }
    })
    if (!res.ok) throw new Error(await res.text())
    const data = await res.json()

    if (data.pays && Array.isArray(data.pays.jobs)) {
      payDetails.value = data.pays.jobs;
      totalPay.value = data.pays.totalPay || 0;
      totalHours.value = data.pays.totalHoursForPay || 0;
      employeeName.value = data.pays.employeeName || 'TBC';
    } else if (Array.isArray(data)) {
      payDetails.value = data
      totalPay.value = 0
      totalHours.value = 0
    } else {
      employeeName.value = data.pays.employeeName || 'TBC'
      totalPay.value = data.totalPay || 0
      totalHours.value = data.pays.totalHoursForPay || 0
      payDetails.value = data.payDetails || data.jobs || []
    }
  } catch (e) {
    alert('Failed to load: ' + (e instanceof Error ? e.message : 'Unknown error'))
  }
}

// ========== NEW: Excel Download Function ==========
const downloadExcel = () => {
  if (!payDetails.value || payDetails.value.length === 0) {
    alert('No data to export.');
    return;
  }

  // Get company name from localStorage
  const companyName = localStorage.getItem("companyName") || 'Company Name';

  // Column headers for Pay Detail
  const headers = [
    'SNo',
    'Site Name',
    'Job Date',
    'Starts',
    'Ends',
    'Hours',
    'Rate',
    '+/-',
    'Remarks',
    'B. Hrs.',
    'Net Hrs.',
    'T. Exp.',
    'Wage'
  ];

  // Start building HTML table
  let html = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office" 
          xmlns:x="urn:schemas-microsoft-com:office:excel" 
          xmlns="http://www.w3.org/TR/REC-html40">
    <head>
      <meta charset="UTF-8">
      <!--[if gte mso 9]>
      <xml>
        <x:ExcelWorkbook>
          <x:ExcelWorksheets>
            <x:ExcelWorksheet>
              <x:Name>Pay Detail Report</x:Name>
              <x:WorksheetOptions>
                <x:DisplayGridlines/>
              </x:WorksheetOptions>
            </x:ExcelWorksheet>
          </x:ExcelWorksheets>
        </x:ExcelWorkbook>
      </xml>
      <![endif]-->
      <style>
        table { 
          border-collapse: collapse; 
          font-family: Calibri, Arial, sans-serif; 
          font-size: 18px;
          width: 100%;
        }
        th, td { 
          border: 1px solid #446ced; 
          padding: 5px 8px; 
        }
        th { 
          background-color: #0000ff; 
          color: #ffffff; 
          font-weight: bold;
          text-align: center;
        }
        .center { text-align: center; }
        .left { text-align: left; }
        .total { 
          font-weight: bold;
          background-color: #D9E1F2;
        }
        .number { 
          text-align: center;
          font-variant-numeric: tabular-nums;
        }
        .top-heading {
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          background-color: #e8f5e9;
          padding: 15px 8px;
        }
        .sub-heading {
          font-size: 16px;
          text-align: left;
          padding: 8px 8px;
          background-color: #f5f5f5;
        }
      </style>
    </head>
    <body>
      <table>
  `;

  // Add top heading row - spans all 12 columns
  html += `<tr>`;
  html += `<td colspan="13" class="top-heading">Pay Detail Report For ${companyName}</td>`;
  html += `</tr>`;

  // Add employee info row
  html += `<tr>`;
  html += `<td colspan="13" class="sub-heading">
    <strong>Employee:</strong> ${employeeName.value} &nbsp;&nbsp;|&nbsp;&nbsp; 
    <strong>Total Pay:</strong> £${Number(totalPay.value).toFixed(2)} &nbsp;&nbsp;|&nbsp;&nbsp; 
    <strong>Total Hours:</strong> ${Number(totalHours.value).toFixed(2)}
  </td>`;
  html += `</tr>`;

// Add headers
html += `<thead><tr>`;
headers.forEach(header => {
  html += `<th>${header}</th>`;
});
html += `</tr></thead><tbody>`;

// Build rows - using correct row index
payDetails.value.forEach((row, idx) => {
  const rowIndex = idx + 4; // Data starts at row 4 (row 1: heading, row 2: sub-heading, row 3: table-header)
  
  html += `<tr>`;
  html += `<td class="center">${idx + 1}</td>`;
  html += `<td class="left">${row.siteInfo || row.siteName || '-'}</td>`;
  html += `<td class="center">${formatDate(row.jobDate)}</td>`;
  html += `<td class="center">${row.startTime ? row.startTime.slice(0,5) : '-'}</td>`;
  html += `<td class="center">${row.endTime ? row.endTime.slice(0,5) : '-'}</td>`;
  html += `<td class="number">${row.dutyHours || 0}</td>`;           // Column F
  html += `<td class="number">${row.payRate || row.rate || 0}</td>`; // Column G
  html += `<td class="number">${row.adjustment || row.adjustmentHours || 0}</td>`; // Column H
  html += `<td class="left">${row.remarks || '-'}</td>`;             // Column I
  html += `<td class="number">${row.bonusHours || 0}</td>`;          // Column J
  html += `<td class="number">=J${rowIndex}+H${rowIndex}+F${rowIndex}</td>`; // Column K (Net Hrs.)
  html += `<td class="number">${row.travelExpense || 0}</td>`;       // Column L
  html += `<td class="number">=K${rowIndex}*G${rowIndex}+L${rowIndex}</td>`; // Column M (Pay)
  html += `</tr>`;
});

// Totals row
html += `<tr class="total">`;
html += `<td colspan="5" style="text-align: right; font-weight: bold;">TOTALS</td>`;
html += `<td class="number">=SUM(F3:F${payDetails.value.length + 2})</td>`; // Total Hours
html += `<td></td>`;
html += `<td class="number">=SUM(H3:H${payDetails.value.length + 3})</td>`;
html += `<td></td>`;
html += `<td class="number">=SUM(J3:J${payDetails.value.length + 3})</td>`;
html += `<td class="number">=SUM(K3:K${payDetails.value.length + 3})</td>`; // Total Net Hours
html += `<td class="number">=SUM(L3:L${payDetails.value.length + 3})</td>`; // Total Travel
html += `<td class="number">=SUM(M3:M${payDetails.value.length + 3})</td>`; // Total Pay
html += `</tr>`;

  html += `</tbody></table></body></html>`;

  // Create and download as .xls
  const blob = new Blob([html], {
    type: 'application/vnd.ms-excel;charset=utf-8'
  });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `Pay_Detail_Report_${employeeName.value}_${new Date().toISOString().slice(0,10)}.xls`;
  link.click();
  URL.revokeObjectURL(link.href);
};
// ========== END: Excel Download Function ==========

onMounted(fetchPayDetail)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, [
        _cache[1] || (_cache[1] = _createTextVNode("PAY DETAIL REPORT ", -1)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
          class: "text-gray-500 hover:text-gray-700 text-right"
        }, "×")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-semibold" }, "Pay Detail For Employee:", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(employeeName.value || 'TBC'), 1)
          ]),
          _createElementVNode("p", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-semibold" }, "Total Pay:", -1)),
            _createElementVNode("span", _hoisted_8, "£" + _toDisplayString(totalPay.value || '0.00'), 1)
          ])
        ]),
        _createElementVNode("button", {
          onClick: downloadExcel,
          class: "bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded flex items-center gap-2",
          disabled: !payDetails.value || payDetails.value.length === 0
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-5 w-5",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            })
          ], -1),
          _createTextVNode(" Download Excel ", -1)
        ]))], 8, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", _hoisted_11, [
          _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "bg-gray-100" }, [
              _createElementVNode("th", { class: "border p-2" }, "SNo"),
              _createElementVNode("th", { class: "border p-2" }, "Site Name"),
              _createElementVNode("th", { class: "border p-2" }, "Job Date"),
              _createElementVNode("th", { class: "border p-2" }, "Starts"),
              _createElementVNode("th", { class: "border p-2" }, "Ends"),
              _createElementVNode("th", { class: "border p-2" }, "Hours"),
              _createElementVNode("th", { class: "border p-2" }, "Rate"),
              _createElementVNode("th", { class: "border p-2" }, "+/-"),
              _createElementVNode("th", { class: "border p-2" }, "Remarks"),
              _createElementVNode("th", { class: "border p-2" }, "B. Hrs."),
              _createElementVNode("th", { class: "border p-2" }, "Net Hrs."),
              _createElementVNode("th", { class: "border p-2" }, "T. Exp.")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (!payDetails.value || payDetails.value.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("td", {
                    colspan: "12",
                    class: "border p-4 text-center text-gray-500"
                  }, "No records found", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payDetails.value, (row, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_13, _toDisplayString(index+1), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(row.siteInfo || row.siteName || '-'), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(formatDate(row.jobDate)), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(row.startTime ? row.startTime.slice(0,5) : '-'), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(row.endTime ? row.endTime.slice(0,5) : '-'), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(row.dutyHours || '-'), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(row.payRate || row.rate || '-'), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(row.adjustment || row.adjustmentHours || '-'), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(row.remarks || '-'), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(row.bonusHours || '-'), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(row.netHours || '-'), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(row.travelExpense || '-'), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("tfoot", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_25, [
                _cache[6] || (_cache[6] = _createTextVNode(" Total Hours = ", -1)),
                _createElementVNode("span", _hoisted_26, _toDisplayString(totalHours.value), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})